import React, { Fragment } from 'react'
import {Header, Image, Item} from "semantic-ui-react"
import MyImage from "../assets/image.png"

/**
* @author
* @function ImageWrapper
**/

const ImageWrapper = (props) => {
  return(
    <Fragment>
        <Item>
        <Image size ="small" style = {{borderRadius : "50%" , textAlign : "center",margin : "auto"}} src={MyImage}/>
        </Item>
        <Header color ="olive" textAlign="center" style ={{margin : "7px",textDecoration : "underline"}}>Ahmer Aftab Patel</Header>
    </Fragment>
   )

 }

export default ImageWrapper